export type ReadMode = 'paged' | 'scroll';
export type ReaderTheme = 'light' | 'sepia' | 'dark';

export interface ReaderPrefs {
  theme: ReaderTheme;
  fontSize: number;
  fontFamily: 'Georgia' | 'Palatino' | 'System';
}

export const DEFAULT_PREFS: ReaderPrefs = {
  theme: 'light',
  fontSize: 17,
  fontFamily: 'Georgia',
};

export function themeBg(theme: ReaderTheme): string {
  if (theme === 'sepia') return '#f5f0e8';
  if (theme === 'dark') return '#1a1a1a';
  return '#ffffff';
}

export function themeText(theme: ReaderTheme): string {
  if (theme === 'dark') return '#e8e8e8';
  if (theme === 'sepia') return '#3a2e1a';
  return '#1a1a1a';
}

export function themeBorder(theme: ReaderTheme): string {
  return theme === 'dark' ? '#333333' : '#e5e7eb';
}

export function themeMuted(theme: ReaderTheme): string {
  return theme === 'dark' ? '#6b7280' : '#9ca3af';
}

export function fontFamilyValue(family: ReaderPrefs['fontFamily']): string {
  if (family === 'Palatino') return "Palatino Linotype, Palatino, serif";
  if (family === 'System') return "-apple-system, BlinkMacSystemFont, sans-serif";
  return "Georgia, 'Times New Roman', serif";
}
